import { Markdown } from "./Markdown";

// Texto de la respuesta: Markdown seguro (negritas, listas, `código`, «---»), 16 px con interlineado amplio.
export function TextSection({ section }) {
  return (
    <div data-testid="typed-section-text" className="text-base leading-7 text-foreground/80 my-2 break-words">
      <Markdown text={section.content} />
    </div>
  );
}
